// ID of information about commitment period
export const COMMITMENT_BALANCE_ID = "21207";

// Id of object where is information about penalty fee
export const COMMITMENT_PENALTY_FEE_ID = "21208";

export const MAX_AMOUNT = 500;
